"use strict";

import "./CreatePOIDialog.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import sessionStore from "./../../store/session";

import uploadPOI from "./../../api/uploadPOI";

import IconSVG from "svg-inline-loader/lib/component";

import geocode from "vwa/geocode";
import lang from "vwa/lang";
import Form from "vwa/components/Form";
import Dialog from "vwa/components/Dialog";
import ProgressBar from "vwa/components/ProgressBar";
import Input from "vwa/components/Input";
import Button from "vwa/components/Button";
import Toast from "vwa/components/Toast";

import polygon from "./polygon.svg";
import circle from "./circle.svg";

const POLYGON = "PolygonalPOI";
const RADIAL = "RadialPOI";

export default class CreatePOIDialog extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			shown:			false,
			inProgress:		false,
			fixLocation:	false,
			poi:			this.getInitialPOI()
		};
	}
	
	getInitialPOI() {
		return {
			type:		"",
			name:		"",
			address:	"",
			location:	null
		};
	}
	
	setPOIState(modifications) {
		Object.assign(this.state.poi, modifications);
		this.forceUpdate();
	}
	
	show(location) {
		this.setState({shown: true});
		if (location) {
			this.setState({fixLocation: true});
			this.setPOIState({location: latLngToPoint(location)});
		} else {
			this.setState({fixLocation: false});
		}
		this.geocodeLocation(location);
	}
	
	hide() {
		this.setState({shown: false});
	}
	
	clear() {
		this.setState({
			poi: this.getInitialPOI()
		});
	}
	
	async geocodeLocation(location) {
		if (!location) return;
		
		this.setState({inProgress: true});
		try {
			const address = await geocode('google', location);
			if (address) this.setPOIState({address});
		} catch (error) {}
		finally {
			this.setState({inProgress: false});
		}
	}
	
	async geocodeAddress(address) {
		if (!address) return;
		
		try {
			const location = await geocode('google', address);
			if (location) this.setPOIState({location: latLngToPoint(location)});
		} catch (error) {}
	}
	
	handleAddressTypeEnd(address) {
		if (this.state.fixLocation)
			return;
		this.geocodeAddress(address);
	}
	
	handleCancel() {
		this.clear();
		this.hide();
	}
	
	async handleSubmit() {
		try {
			await this.upload();
			this.clear();
			this.hide();
		} catch (error) {}
	}
	
	getSubmitButtonDisabled() {
		return (!this.state.poi.location ||
				!this.state.poi.name ||
				!this.state.poi.address ||
				!this.state.poi.type) ||
				this.state.inProgress;
	}
	
	getCancelButtonDisabled() {
		return this.state.inProgress;
	}
	
	getPOIFromState() {
		const poi = {
			type:		this.state.poi.type,
			name:		this.state.poi.name,
			address:	this.state.poi.address,
			location:	this.state.poi.type == RADIAL ? this.state.poi.location : createInitialPolygon(this.state.poi.location)
		};
		
		if (this.state.poi.type == RADIAL)
			poi.radius = 100;
		
		return poi;
	}
	
	async upload() {
		this.setState({inProgress: true});
		await uploadPOI(this.getPOIFromState());
		this.setState({inProgress: false});
	}
	
	render() {
		
		const className = classnames("CreatePOIDialog", {"InProgress": this.state.inProgress});
		
		return (
			<Dialog className={className} shown={this.state.shown}>
				<header><h1>{lang.CREATE_POI_DIALOG_TITLE}</h1></header>
				<Form>
					<div id="progressBarContainer">
						<ProgressBar indeterminate/>
					</div>
					<label>{lang.NAME}</label>
					<Input value={this.state.poi.name} onChange={evt => this.setPOIState({name: evt.target.value})}/>
					<label>{lang.ADDRESS}</label>
					<Input value={this.state.poi.address} onChange={evt => this.setPOIState({address: evt.target.value})} onTypeEnd={value => this.handleAddressTypeEnd(value)}/>
					<label>{lang.SHAPE}</label>
					<div id="shapeSelector">
						<div className={this.state.poi.type == POLYGON ? "Selected" : ""} onClick={_ => this.setPOIState({type: POLYGON})}>
							<IconSVG src={polygon}/>
							<label>{lang.POLYGON_SHAPE}</label>
						</div>
						<div className={this.state.poi.type == RADIAL ? "Selected" : ""} onClick={_ => this.setPOIState({type: RADIAL})}>
							<IconSVG src={circle}/>
							<label>{lang.CIRCLE_SHAPE}</label>
						</div>
					</div>
				</Form>
				<footer>
					<Button onClick={_ => this.handleCancel()} disabled={this.getCancelButtonDisabled()}>{lang.CANCEL}</Button>
					<Button onClick={_ => this.handleSubmit()} className="Red" disabled={this.getSubmitButtonDisabled()}>{lang.CREATE}</Button>
				</footer>
			</Dialog>
		);
	}
	
}

CreatePOIDialog.propTypes = {
	
};

CreatePOIDialog.defaultProps = {
	
};

function latLngToPoint(latLng) {
	if (!latLng) return null;
	return {
		type: "Point",
		coordinates: [latLng.lng(), latLng.lat()]
	};
}

function createInitialPolygon(location) {
	if (!location) return null;
	const lat = location.coordinates[1];
	const lng = location.coordinates[0];
	return {
		type: "MultiPolygon",
		coordinates : [[[
			[lng-0.001, lat-0.001],
			[lng-0.001, lat+0.001],
			[lng+0.001, lat+0.001],
			[lng+0.001, lat-0.001],
			[lng-0.001, lat-0.001]
		]]]
	};
}


// WEBPACK FOOTER //
// ./src/view/CreatePOIDialog/CreatePOIDialog.jsx